const MERCHANT_NAV_ITEM = Object.freeze({
  id: "merchant-store",
  title: "فروشگاه من",
  route: "merchantStore",
});

function isMerchantContext(context) {
  return Boolean(
    context &&
      Array.isArray(context.workspaces) &&
      context.workspaces.includes("merchant")
  );
}

function mergeMerchantNavigation(items, context) {
  const baseItems = Array.isArray(items)
    ? items.filter((item) => item && item.route !== MERCHANT_NAV_ITEM.route)
    : [];

  return isMerchantContext(context)
    ? [...baseItems, { ...MERCHANT_NAV_ITEM }]
    : baseItems;
}

function normalizeDigits(value) {
  return String(value || "")
    .replace(/[۰-۹]/g, (digit) => String("۰۱۲۳۴۵۶۷۸۹".indexOf(digit)))
    .replace(/[٠-٩]/g, (digit) => String("٠١٢٣٤٥٦٧٨٩".indexOf(digit)));
}

function normalizeBarcode(value) {
  return normalizeDigits(value).replace(/\D/g, "");
}

function parseRialAmount(value) {
  const normalized = normalizeDigits(value).replace(/\D/g, "");
  return normalized ? Number(normalized) : null;
}

module.exports = {
  MERCHANT_NAV_ITEM,
  isMerchantContext,
  mergeMerchantNavigation,
  normalizeBarcode,
  parseRialAmount,
};
